import React, {ChangeEvent, Dispatch, SetStateAction, useContext, useState} from "react";
import {Button, Form, Input, List, Modal} from "antd";
import {DeleteOutlined, EyeOutlined} from "@ant-design/icons";
import styled from "styled-components";
import ProductRuleCondition from "./ProductRuleCondition";
import ProductRuleAction from "./ProductRuleAction";
import {ProductRuleType} from "../tabs/ProductRules";
import {CatalogContext} from "../../../../providers/CatalogProvider";

type ProductRuleProps = {
    rule: ProductRuleType
    removedRules: number[]
    setRemovedRules: Dispatch<SetStateAction<number[]>>
}

export const ProductRule = (
    {removedRules, setRemovedRules, rule}: ProductRuleProps
) => {
    const {rules, setRules} = useContext(CatalogContext)
    const [isOpenModal, setIsOpenModal] = useState(false)

    const handleChangeRuleName = (e: ChangeEvent<HTMLInputElement>) => {
        setRules(rules.map(item => {
            return {
                ...item,
                name: item.id === rule.id ? e.target.value : item.name,
                status: item.id === rule.id ? 'changed' : item.status,
            }
        }))
    }

    const handleDeleteRule = (rule: ProductRuleType) => {
        if (!rule.newItem) setRemovedRules([...removedRules, rule.id])
        setRules(rules.filter(item => item.id !== rule.id))
    }

    return (
        <StyledRuleWrapper key={rule.id}>
            <Button
                onClick={() => setIsOpenModal(true)}
                type="link"
                size="small"
            >
                <EyeOutlined/>
                {rule.name}
            </Button>

            <Button
                onClick={() => handleDeleteRule(rule)}
                type="link"
                size="small"
            >
                <DeleteOutlined/>
            </Button>

            <Modal
                title="Rule Setup"
                centered
                open={isOpenModal}
                onCancel={() => setIsOpenModal(false)}
                footer={[
                    <Button
                        type="primary"
                        key="save"
                        onClick={() => setIsOpenModal(false)}
                        htmlType="button"
                    >
                        Save
                    </Button>
                ]}
            >
                <Form layout="vertical">
                    <Form.Item label="Name">
                        <Input maxLength={40} placeholder="Name" value={rule.name} onChange={handleChangeRuleName}/>
                    </Form.Item>

                    <ProductRuleCondition rule={rule}/>
                    <ProductRuleAction rule={rule}/>
                </Form>
            </Modal>
        </StyledRuleWrapper>
    )
}

export default ProductRule

type DropdownType = { id: number, label: string, disabled: boolean }

export type ProductRuleActions = Record<string, DropdownType>

const StyledRuleWrapper = styled(List.Item)`
    display: flex;
    align-items: center;
`
